export default function Rust_WhileLoops() {
  return (
    <div>
      <h1>Rust_WhileLoops Component</h1>
      <p>This is the Rust_WhileLoops page.</p>
    </div>
  );
}
